var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTakePicture = function SvgTakePicture(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 15.8631C13.7669 15.8631 15.1996 14.4304 15.1996 12.6631C15.1996 10.8958 13.7669 9.46307 11.9996 9.46307C10.2323 9.46307 8.79964 10.8958 8.79964 12.6631C8.79964 14.4304 10.2323 15.8631 11.9996 15.8631Z",
    fill: "#499CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99963 2.66309L7.16963 4.66309H3.99963C2.89963 4.66309 1.99963 5.56309 1.99963 6.66309V18.6631C1.99963 19.7631 2.89963 20.6631 3.99963 20.6631H19.9996C21.0996 20.6631 21.9996 19.7631 21.9996 18.6631V6.66309C21.9996 5.56309 21.0996 4.66309 19.9996 4.66309H16.8296L14.9996 2.66309H8.99963ZM11.9996 17.6631C9.23963 17.6631 6.99963 15.4231 6.99963 12.6631C6.99963 9.90309 9.23963 7.66309 11.9996 7.66309C14.7596 7.66309 16.9996 9.90309 16.9996 12.6631C16.9996 15.4231 14.7596 17.6631 11.9996 17.6631Z",
    fill: "#499CE0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTakePicture);
export { ForwardRef as ReactComponent };